import {
  usePeopleQuery,
  usePeopleLazyQuery,
  PeopleFilter,
  Person,
} from "@/features/people/graphql/generated";
import { useAccount } from "./useAccount";

export const useLazyAccountMembers = () => {
  const [fetchAccountMembers, { data, loading }] = usePeopleLazyQuery({
    variables: {
      filter: {},
    },
  });

  return {
    fetchAccountMembers,
    data,
    loading,
  };
};

export const useAccountMembers = () => {
  const { account } = useAccount();

  const { data, loading } = usePeopleQuery({
    variables: {
      filter: {} as PeopleFilter,
    },
    skip: !account.id,
  });

  const accountMembers = (data?.people || []) as Person[];

  const totalCount = data?.people?.length || 0;

  return {
    accountMembers,
    totalCount,
    loading,
  };
};
